import { atom } from "jotai";

export const sidebarState = atom<boolean>(false);

export const embeddedWalletProfileState = atom<boolean>(false);

export const embeddedWalletModalState = atom<boolean>(false);

export const accountCreationModalState = atom<boolean>(false);

export const fundingModalState = atom<boolean>(false);
export const fundingModalTab = atom<"moveIn" | "moveOut">("moveIn");

export const loginInProgressState = atom<boolean>(false);

export const showOrderbookVAMM = atom<boolean>(true);

export const betslipModalState = atom<boolean>(false);

export const appLoaderState = atom<boolean>(true);

export const marketDetailModalState = atom<boolean>(false);

export const onboardingProgressState = atom<boolean>(false);
export const onboardingStepState = atom<number>(0);

export const placeBetProgressState = atom<number>(0);

export const priceInfoModalState = atom<boolean>(false);
export const winLossInfoModalState = atom<boolean>(false);
export const liquidationPriceInfoModalState = atom<boolean>(false);

export const howItWorksModalState = atom<boolean>(false);

export const appSidebarState = atom<boolean>(false);

// Global loading atom to control loading overlays or hide components
export const globalLoadingAtom = atom(false);

export const imageGenModalState = atom<boolean>(false);

export const vaultsPageTabState = atom<"deposits" | "depositors">("deposits");
